import RaidPlan, { RaidPlanCast } from 'app/frontend/types/custom/RaidPlan'

export const formatFightDuration = (durationMs: number) => {
  const totalSeconds = Math.max(0, Math.floor(durationMs / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export const getTopExecutionKillTimeline = (
  kill: wowaudit.RaidReportTopExecutionKill,
) => {
  return kill.timeline as RaidPlan['timeline']
}

export const cloneActorCasts = (casts: RaidPlanCast[]) => {
  return JSON.parse(JSON.stringify(casts)) as RaidPlanCast[]
}
